import { Component, Input } from '@angular/core';
import PartnerTaskTypeAllocation = Boo.Objects.Work.PartnerTaskTypeAllocation;

@Component({
  selector: 'app-components-manager-allocation-test-results',
  templateUrl: './allocation-test-results.component.html',
  styleUrls: ['./allocation-test-results.component.scss']
})
export class AllocationTestResultsComponent {
  @Input() taskTypeAllocations: PartnerTaskTypeAllocation[];
  @Input() testedHours: number;

  get minutes(): number {
    return this.testedHours * 60;
  }

  get isAllocationValid(): boolean {
    return this.allocatedMinutes <= this.minutes;
  }

  get allocatedMinutes(): number {
    if (!this.taskTypeAllocations.length) {
      return 0;
    }

    return this.taskTypeAllocations.map(item => item.TaskType.BillableMinutes * item.TaskCount).reduce((a, b) => a + b);
  }

  get unallocatedMinutes(): number {
    return Math.max(0, this.minutes - this.allocatedMinutes);
  }

  get minuteDifferenceMessage(): string {
    if (this.minutes > this.allocatedMinutes + this.unallocatedMinutes) {
      return `${ this.minutes - this.allocatedMinutes } Under`;
    } else {
      return `${ this.allocatedMinutes - this.minutes } Over`;
    }
  }

  get showTable(): boolean {
    return this.taskTypeAllocations?.some(x => x.TaskCount) || this.unallocatedMinutes > 0;
  }
}